"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSwapHalfSpreads = void 0;
const typeguard_1 = require("../types/typeguard");
const PrintableAction_1 = require("./PrintableAction");
const layers_1 = require("../services/layers");
const swapHalfSpreadsRuleSet = {
  type: value => value === 'SWAP_HALF_SPREADS',
  sourceSide: value => Object.values(layers_1.SpreadSide).includes(value),
  targetPrintableId: typeguard_1.isNonEmptyString,
  targetSide: value => Object.values(layers_1.SpreadSide).includes(value)
};
const isSwapHalfSpreads = p => {
  return (0, PrintableAction_1.isPrintableAction)(p) && p && (0, typeguard_1.isType)(p, swapHalfSpreadsRuleSet);
};
exports.isSwapHalfSpreads = isSwapHalfSpreads;